import { OdataManager } from '@/api/odata/odata-manager';
import { RegisterStatusHistory } from '@/api/model/interfaces';

export default class RegisterStatusHistoryOdata extends OdataManager<RegisterStatusHistory> {}
